// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dJmGKfdhQkamUCjV {
    display: flex;
    margin-bottom: var(--lok-spacing-1);
    width: 100%;
    align-items: center;
}

.G6aHh4PrS0b5i9fX {
    display: flex;
    list-style: none;
    flex-wrap: wrap;
    margin: 0 0 0 calc(-1 * var(--lok-spacing-6));
    padding: 0;
}

.Tsbu1vyERlk3rHNZ {
    border: none;
    margin: 0;
    border-bottom: 2px solid transparent;
    background: none;
    appearance: none;

    font: var(--lok-typography-body-small-default);
    color: var(--lok-color-text-default);
    margin: 0 0 0 var(--lok-spacing-6);

    &[aria-selected='true'] {
        font-weight: 500;
        color: var(--lok-color-text-active);
        border-bottom-color: var(--lok-color-text-active);
    }
}

.nrOta6_B28MGVS2J {
    display: flex;
    justify-content: space-between;
    gap: var(--lok-spacing-2);
    flex-wrap: nowrap;
}

.GRN1y1pZA68rLfDr {
    position: fixed;
    background-color: var(--lok-color-background-surface-default);
    top: 0;
    left: 95px;
    right: 32px;
    z-index: 899;

    padding-top: var(--lok-spacing-5);
    padding-left: 30px;
    padding-right: 30px;
    margin-left: -30px;
    margin-right: -30px;
    border-bottom: 1px solid var(--lok-color-border-default);
}

.GgLXvo8lH0gGVvs7 {
    z-index: var(--lok-z-index-auto);
    position: relative;
    top: inherit;
    left: 0;
    right: 0;
    padding-top: 0;
    box-shadow: none;
}
`, "",{"version":3,"sources":["webpack://./src/app/features/project/components/ProjectNavigationPanel/styles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mCAAmC;IACnC,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,6CAA6C;IAC7C,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,oCAAoC;IACpC,gBAAgB;IAChB,gBAAgB;;IAEhB,8CAA8C;IAC9C,oCAAoC;IACpC,kCAAkC;;IAElC;QACI,gBAAgB;QAChB,mCAAmC;QACnC,iDAAiD;IACrD;AACJ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,6DAA6D;IAC7D,MAAM;IACN,UAAU;IACV,WAAW;IACX,YAAY;;IAEZ,iCAAiC;IACjC,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,wDAAwD;AAC5D;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,cAAc;IACd,gBAAgB;AACpB","sourcesContent":[".headerContainer {\n    display: flex;\n    margin-bottom: var(--lok-spacing-1);\n    width: 100%;\n    align-items: center;\n}\n\n.navigationTabList {\n    display: flex;\n    list-style: none;\n    flex-wrap: wrap;\n    margin: 0 0 0 calc(-1 * var(--lok-spacing-6));\n    padding: 0;\n}\n\n.navigationTab {\n    border: none;\n    margin: 0;\n    border-bottom: 2px solid transparent;\n    background: none;\n    appearance: none;\n\n    font: var(--lok-typography-body-small-default);\n    color: var(--lok-color-text-default);\n    margin: 0 0 0 var(--lok-spacing-6);\n\n    &[aria-selected='true'] {\n        font-weight: 500;\n        color: var(--lok-color-text-active);\n        border-bottom-color: var(--lok-color-text-active);\n    }\n}\n\n.tabsContainer {\n    display: flex;\n    justify-content: space-between;\n    gap: var(--lok-spacing-2);\n    flex-wrap: nowrap;\n}\n\n.headerContent {\n    position: fixed;\n    background-color: var(--lok-color-background-surface-default);\n    top: 0;\n    left: 95px;\n    right: 32px;\n    z-index: 899;\n\n    padding-top: var(--lok-spacing-5);\n    padding-left: 30px;\n    padding-right: 30px;\n    margin-left: -30px;\n    margin-right: -30px;\n    border-bottom: 1px solid var(--lok-color-border-default);\n}\n\n.staticEnabled {\n    z-index: var(--lok-z-index-auto);\n    position: relative;\n    top: inherit;\n    left: 0;\n    right: 0;\n    padding-top: 0;\n    box-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerContainer": `dJmGKfdhQkamUCjV`,
	"navigationTabList": `G6aHh4PrS0b5i9fX`,
	"navigationTab": `Tsbu1vyERlk3rHNZ`,
	"tabsContainer": `nrOta6_B28MGVS2J`,
	"headerContent": `GRN1y1pZA68rLfDr`,
	"staticEnabled": `GgLXvo8lH0gGVvs7`
};
export default ___CSS_LOADER_EXPORT___;
